import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import logBehaviorMixin from 'next/javascripts/mixins/log-behavior-mixin';
import 'next/stylesheets/components/teams/init-scene.scss';

Component('tr-team-init-scene', {
  properties: {
    isOnboarding: Boolean,
  },

  mixins: [eventListenerMixin, logBehaviorMixin],

  connected() {
    this.submitButton = this.querySelector('form button[type="submit"]');
    this.sceneInput = this.querySelector('.scene-desc-input input');

    this.listenTo(this, 'tr-checkbox-field:change', ({ target: checkbox }) => {
      if (checkbox.getValue() === 'other' && checkbox.checked) {
        this.sceneInput.focus();
      }
      this.toggleSubmitButton();
    });

    this.listenTo(this.sceneInput, 'input', this.toggleSubmitButton.bind(this));
    this.listenTo(this.submitButton, 'click', this.beforeSubmit.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  toggleSubmitButton() {
    const selctedScenes = [...this.querySelectorAll('tr-checkbox-field[checked]')]
      .map(checkbox => checkbox.getValue());
    let enabled = selctedScenes.filter(scene => scene !== 'other').length > 0;

    if (!enabled && selctedScenes.indexOf('other') !== -1) {
      enabled = !!this.sceneInput.value;
    }

    this.submitButton.disabled = !enabled;
  },

  beforeSubmit() {
    if (!this.isOnboarding) return;
    const scenes = [];
    this.querySelector('form').querySelectorAll('input[type="checkbox"]:checked')
      .forEach(e => scenes.push(e.value));
    this.sendLogBehavior({
      resourceType: 'OnboardingGuide',
      resourceId: 1,
      extraValues: {
        stage: 'init_scenes',
        scenes,
      },
    });
  },
});
